export default __webpack_public_path__ + "static/media/fbbank.0f97ac8f.jpg";